import axios from "axios";
import React, {useEffect, useState} from "react";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function AddConsDept() {
    const [dept, setdept] = useState([]);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [deptData, setdeptData] = useState({
        "department": '',
        "status": '',
        "addedby": '',
        "ip_add": ''
    });
    const handleChange = (event) => {
        setdeptData({
            ...deptData,
            [event.target.name]: event.target.value
        });
    }
    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('department', deptData.department);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.post(baseUrl + 'cons-dept/', _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200 || response.status == 201) {
                        Swal.fire({
                            title: 'Department Added Successfully',
                            icon: 'success',
                            timer: 8001,
                            showConfirmButton: false
                        });
                        setTimeout(() => {
                            window.location.href = '/add-cons-dept/';
                        }, 2000);
                    }
                });
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);
    useEffect(() => {
        if (dept.length > 0) {
            setRows(dept);
        }
    }, [dept]);
    function fetchData() {
        setIsLoading(true);
        axios.get(`${baseUrl}cons-dept/`)
            .then(response => {
                setdept(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const handleDelete = (dept_id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-cons-dept/' + dept_id)
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                            window.location.reload();
                        });
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    const columns = [
        {field: 'id', headerName: 'Id', width: 160},
        {field: 'department', headerName: 'Department', width: 500},
        {field: 'addedby', headerName: 'Added By', width: 200},
        {
            field: 'delete', headerName: 'Action',
            renderCell: (params) => (
                <button onClick={() => handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
                    <i className="fa-solid fa-trash-can"></i></button>
            ),
            width: 120
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row">

                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Add Department</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="department" className="form-label">Department</label>
                                    <input type="text" className="form-control" name="department"
                                           value={deptData.department}
                                           onChange={handleChange} id="department"/>
                                </div>

                                <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>


            <div style={{height: "100%", width: "100%"}}>
                <DataGrid className="mt-4"
                          sx={{
                              boxShadow: 4,
                              border: 4,
                              borderColor: 'primary.light',
                              '& .MuiDataGrid-cell:hover': {
                                  color: 'primary.main',
                              },
                          }}
                          pageSize={28}
                          rows={rows}
                          columns={columns}
                          components={{
                              Toolbar: GridToolbar,
                          }}
                          autoHeight
                />
            </div>

        </section>
    )
}
export default AddConsDept;